module.exports = __webpack_public_path__ + "img/git.ba651522.png";